import { useLocation } from 'react-router';
import React from 'react';
import { fromEntries } from 'helpers/polyfills';

/** For use with React-Router only!! */
export const useQueryParams = <T = any>() => {
  const location = useLocation();

  const urlSearchParams = React.useMemo(() => new URLSearchParams(location.search), [location.search]);
  const params: T = (React.useMemo(() => fromEntries(urlSearchParams.entries()), [urlSearchParams]) as unknown) as T;

  return {
    urlSearchParams,
    params,
  };
};
